export const tr = {
  uploading: "Yükle ...",
  uploaded: "yüklenen",
  fetching: "$1$ 'dan resim al ...",
  poweredBy: "$1$ ile mümkün oldu",
  needHelp: "Yardıma mı ihtiyacınız var?",
  units: {
    px: "px",
    "%": "%",
    deg: "°"
  },
  errors: {
    response_not_ok: "Bu dosya alınırken bir hata oluştu",
    unable_to_search: "Aranırken bir hata oluştu",
    invalid_service_url: "Bu bir $1$ URL değil",
    invalid_url: "Bu URL geçersiz",
    upload_aborted: "Yüklemeniz iptal edildi",
    upload_error: "Bu dosya yüklenirken bir hata oluştu",
    file_type_not_allowed: "Bu dosya türü desteklenmiyor",
    file_too_large: "Dosya $1$ 'dan az olmalı"
  },
  help: {
    loading: "Yardım yükleniyor...",
    close: "Yardımı kapat"
  },
  services: {
    default: {
      heading: "Bir resim seç"
    },
    local: {
      title: "Bir dosya seç",
      button: "Bir dosya seç",
      or: "arasında",
      drop: "Yüklemek için bir dosyayı buraya sürükleyin"
    },
    camera: {
      title: "Kamera",
      button: "Webcam fotoğraf",
      switch: "Kamera değiştir",
      waiting: "Kamera izni bekleniyor ...",
      unableToRead:
        "Videoyu kameranızdan okuyamıyoruz. Bunun nedeni gerekli izni vermediğiniz veya cihazınızın kamera erişimini desteklememesi olabilir."
    },
    microlink: {
      button: "1 $ 'dan içe aktar",
      label: "$1$ $2$ URL",
      placeholder: "Bir $1$ $2$ URL girin",
      type: "posta"
    },
    url: {
      title: "Doğrudan URL",
      label: "Image URL",
      placeholder: "Bir resim URL’si girin"
    },
    instagram: {
      title: "Instagram"
    },
    facebook: {
      title: "Facebook"
    },
    flickr: {
      title: "Flickr",
      type: "bir fotoğraf"
    },
    ninegag: {
      title: "9gag",
      type: "bir fotoğraf"
    },
    deviantart: {
      title: "DeviantArt"
    },
    artstation: {
      title: "ArtStation"
    },
    twitter: {
      title: "heyecan",
      type: "fotoğraf tweet"
    },
    pinterest: {
      title: "pinterest",
      type: "toplu iğne"
    },
    flipboard: {
      title: "Flipboard",
      type: "makale"
    },
    fotki: {
      title: "Resimler",
      type: "bir fotoğraf"
    },
    linkedin: {
      title: "LinkedIn"
    },
    reddit: {
      title: "Reddit"
    },
    tumblr: {
      title: "Tumblr"
    },
    weheartit: {
      title: "Biz kalp"
    },
    screenshot: {
      title: "Ekran görüntüsü",
      button: "Ekran görüntüsü al",
      label: "Web sayfasının URL'si",
      placeholder: "Bir URL girin",
      loading: "Ekran görüntüsü al ..."
    },
    search: {
      button: "$1$ için ara",
      label: "Bir resim arayın",
      placeholder: "Bir şey arayın",
      imagesPoweredBy: "Görüntüler $1$ 'a kadar mümkün kılındı"
    },
    giphy: {
      title: "GIPHY"
    },
    unsplash: {
      title: "Unsplash"
    },
    pixabay: {
      title: "Pixabay"
    },
    pexels: {
      title: "Pexels"
    }
  },
  effects: {
    preview: {
      title: "örnek"
    },
    filters: {
      title: "Filtreler"
    },
    crop: {
      title: "ekin",
      aspectRatios: {
        free: "Ücretsiz",
        square: "tam"
      }
    },
    rotate: {
      title: "büküm"
    },
    flip: {
      title: "Arkanı dön",
      buttons: {
        horizontal: "yatay",
        vertical: "dikey"
      }
    },
    sharpen: {
      title: "keskinleştirme"
    },
    blur: {
      title: "karartmak"
    },
    brightness: {
      title: "parlaklık"
    },
    contrast: {
      title: "Kontrast"
    },
    grayscale: {
      title: "Gri tonlama"
    },
    "hue-rotate": {
      title: "Tonu döndür"
    },
    invert: {
      title: "Ters çevir"
    },
    saturate: {
      title: "doyurmak"
    },
    sepia: {
      title: "Sepya"
    }
  }
};
